// extracted by mini-css-extract-plugin
module.exports = {"container":"sub_header-module__container--2b-B1"};